import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-bulk-run-filtered-accounts-confirmation',
  templateUrl: './bulk-run-filtered-accounts-confirmation.html',
  styleUrls: ['./bulk-run-filtered-accounts-confirmation.scss'],
})
export class BulkRunFilteredAccountsConfirmationModal {
  @Input() numberOfRuns = 0
  confirmationInput: number | undefined = undefined
  isSaveDisabled = true
  constructor(public activeModal: NgbActiveModal) {}

  onConfirmationInputChange() {
    this.isSaveDisabled = this.confirmationInput !== this.numberOfRuns
  }
}
